import { useState, useEffect, useRef } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const faqs = [
    {
      question: 'O que são esquadrias de alumínio?',
      answer: 'Esquadrias em alumínio são estruturas utilizadas para a construção de janelas, portas, fachadas e outros elementos arquitetônicos em edifícios. Elas são fabricadas a partir de perfis de alumínio, que oferecem alta resistência e durabilidade.',
    },
    {
      question: 'Quais são os tipos de esquadrias de alumínio?',
      answer: 'Existem vários tipos de esquadrias de alumínio, incluindo janelas deslizantes, janelas pivotantes, janelas basculantes, janelas de correr, portas de correr, portas pivotantes, portas de abrir e fachadas.',
    },
    {
      question: 'Quais são as vantagens das esquadrias em alumínio?',
      answer: 'As esquadrias em alumínio apresentam diversas vantagens, como alta resistência, durabilidade, baixa manutenção, facilidade de limpeza, possibilidade de personalização, além de serem resistentes à corrosão e à umidade.',
    },
    {
      question: 'Como escolher o tipo de esquadria em alumínio ideal para o meu projeto?',
      answer: 'A escolha do tipo de esquadria ideal depende de diversos fatores, como as dimensões do vão, o tipo de abertura desejado, o ambiente onde será instalada, entre outros.',
    },
    {
      question: 'Como é feita a instalação das esquadrias em alumínio?',
      answer: 'A instalação das esquadrias em alumínio deve ser realizada por profissionais especializados, que seguirão todas as normas de segurança e qualidade necessárias. O processo envolve a medição do vão, a confecção das esquadrias sob medida, a preparação do local para a instalação e a fixação das esquadrias.',
    },
    {
      question: 'É possível personalizar as esquadrias em alumínio?',
      answer: 'Sim, é possível personalizar as esquadrias em alumínio de acordo com as necessidades do projeto, como a escolha da cor, textura, acabamento, entre outras opções.',
    },
    {
      question: 'Como realizar a manutenção das esquadrias em alumínio?',
      answer: 'A manutenção das esquadrias em alumínio é bastante simples e envolve apenas a limpeza regular com água e sabão neutro, além da verificação periódica do estado dos componentes, como roldanas, trincos e vedantes. É importante evitar o uso de produtos químicos agressivos ou abrasivos na limpeza.',
    },
  ];

  return (
    <section ref={sectionRef} className="py-12 md:py-16 lg:py-24 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 mb-3 md:mb-4">
            PERGUNTAS FREQUENTES
          </h2>
        </div>

        <div className="max-w-4xl mx-auto space-y-3 md:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`bg-white rounded-lg shadow-md overflow-hidden transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full flex items-center justify-between p-4 md:p-6 text-left hover:bg-gray-50 transition-colors duration-300"
              >
                <span className="flex items-center space-x-3 md:space-x-4 flex-1 pr-2">
                  <i
                    className={`${
                      openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                    } text-xl md:text-2xl text-[#C0C0C0] flex-shrink-0`}
                  ></i>
                  <span className="text-sm md:text-base lg:text-lg font-semibold text-gray-900">
                    {faq.question}
                  </span>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-4 md:px-6 pb-4 md:pb-6 pt-0 animate-fadeIn">
                  <p className="text-xs md:text-sm lg:text-base text-gray-600 leading-relaxed pl-8 md:pl-12">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
